export default __webpack_public_path__ + "static/media/nurturebox-full.39cfdc72.svg";